import * as React from 'react';

export const Footer = () => (
  <footer className="footer bg-white">
    <div className="container text-center">
      <small className="text-muted">
        Made with ❤️ by Goldbelly&rsquo;s Product Team. &middot; {process.env.GIT_SHA}
      </small>
    </div>
  </footer>
);
